import React from 'react';
import * as RadixDialog from '@radix-ui/react-dialog';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden';
import styles from './Dialog.module.scss';
import { Icon } from '../Icon/Icon';

interface Props {
  open: boolean;
  setOpen?: (open: boolean) => void;
  classname?: string;
  title?: JSX.Element;
  description?: JSX.Element;
  descriptionClassname?: string;
  content?: JSX.Element;
  close?: boolean;
  noPadding?: boolean;
  anchorBottom?: boolean;
}

export function Dialog(props: Props) {
  const { t } = useTranslation();
  const {
    open,
    setOpen,
    classname,
    title,
    description,
    descriptionClassname,
    content,
    close,
    noPadding,
    anchorBottom,
  } = props;
  return (
    <RadixDialog.Root open={open} onOpenChange={setOpen}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className={styles.dialogOverlay} />
        <RadixDialog.Content
          className={classNames(styles.dialogContent, classname, {
            [styles.anchorBottom]: anchorBottom,
            [styles.noPadding]: noPadding,
          })}
        >
          {close && setOpen && (
            <RadixDialog.Close asChild>
              <button
                type="button"
                className={styles.closeButton}
                onClick={() => {
                  setOpen(false);
                }}
                aria-label={t('icons.close')}
              >
                <Icon name="close" />
              </button>
            </RadixDialog.Close>
          )}
          {title && <RadixDialog.Title className={classNames(styles.dialogTitle)}>{title}</RadixDialog.Title>}
          {!description && (
            <RadixDialog.Description>
              <VisuallyHidden>{t('hidden.dialog')}</VisuallyHidden>
            </RadixDialog.Description>
          )}
          {description && (
            <RadixDialog.Description className={classNames(styles.dialogDescription, descriptionClassname)}>
              {description}
            </RadixDialog.Description>
          )}
          {content && <div>{content}</div>}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
